import { CatalogItem, CatalogItemObject, CatalogType, UnitType } from "types";
import { useAutoFetchCollection } from "../useAutoFetchCollection";

const defaultParams = {
    unitType: UnitType.DEMOGRAPHIC,
    object: CatalogItemObject.GLOBAL_CATALOG_ITEM,
};

interface paramsType {
    object: CatalogItemObject;
    unitType?: UnitType;
    product?: string;
    "unitType[in]"?: string;
    "type[nin]"?: CatalogType;
    "deletedAt[exists]"?: boolean;
}

export const useCatalogItems = (params: paramsType = defaultParams, options = {}) => {
    const query = useAutoFetchCollection<CatalogItem>("catalogItems", params, options);

    const { data, isLoading, isFetching } = query;

    return { data, isLoading, isFetching };
};
